/**
 * Anulación manual de una tarea del ERP — backend REAL (solo Administrador).
 *
 * GET  /api/despacho/tareas/:erpId?glnId=N
 * POST /api/despacho/tareas/:erpId/anular { glnId, justificacion }
 */

import {
  AnularTareaResponse,
  TareaParaAnularSchema,
  type AnularTareaResult,
  type TareaParaAnular,
} from '@/api/contracts/anular-tarea';
import { apiFetch } from '@/api/http';

export async function getTareaParaAnular(
  erpId: string,
  glnId: string | number,
): Promise<TareaParaAnular> {
  const data = await apiFetch<unknown>(
    `/despacho/tareas/${encodeURIComponent(erpId)}?glnId=${encodeURIComponent(String(Number(glnId)))}`,
    { auth: true },
  );
  return TareaParaAnularSchema.parse(data);
}

export async function anularTarea(
  erpId: string,
  glnId: string | number,
  justificacion: string,
): Promise<AnularTareaResult> {
  const data = await apiFetch<unknown>(`/despacho/tareas/${encodeURIComponent(erpId)}/anular`, {
    method: 'POST',
    body: { glnId: Number(glnId), justificacion },
    auth: true,
  });
  return AnularTareaResponse.parse(data);
}
